import * as React from "react";

const GroupBy = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <g strokeWidth={4}>
        <g stroke="#7B838C">
          <path d="M29 26h6v2h-6zM41 26h6v2h-6z" />
        </g>
        <g stroke="#7B838C">
          <path d="M29 18h6v2h-6zM41 18h6v2h-6z" />
        </g>
        <path d="M17 22h6v2h-6z" stroke="#4A90E2" />
        <g stroke="#7B838C">
          <path d="M29 44h6v2h-6zM41 44h6v2h-6z" />
        </g>
        <g stroke="#7B838C">
          <path d="M29 36h6v2h-6zM41 36h6v2h-6z" />
        </g>
        <path d="M17 40h6v2h-6z" stroke="#4A90E2" />
      </g>
    </g>
  </svg>
);

export default GroupBy;

